import { render, staticRenderFns } from "./ViewAllInterviewers.vue?vue&type=template&id=6712e260&scoped=true&"
import script from "./ViewAllInterviewers.vue?vue&type=script&lang=ts&"
export * from "./ViewAllInterviewers.vue?vue&type=script&lang=ts&"
import style0 from "./ViewAllInterviewers.vue?vue&type=style&index=0&id=6712e260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6712e260",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VChip,VDialog,VIcon,VImg,VTooltip})
